module.exports = __webpack_public_path__ + "img/question_freq.235a24a2.png";